<script>
localStorage.setItem("rightbar_isopen", false);
import { layoutMethods } from "@/Template/State/Helpers";

export default {
  methods: {
    ...layoutMethods,
    setTheme(theme) {
      this.changeMode({ mode: theme });
      this.changeTopbar({ topbar: theme });

      localStorage.setItem("theme", theme);
      document.documentElement.setAttribute("data-bs-theme", theme);
    },
    topFunction() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
  },
  mounted() {
    const root = document.documentElement;

    root.setAttribute("data-layout", "vertical");
    root.setAttribute("data-layout-width", "fluid");
    root.setAttribute("data-layout-position", "fixed");
    root.setAttribute("data-topbar", "light");
    root.setAttribute("data-sidebar-size", "lg");
    root.setAttribute("data-layout-style", "default");
    root.setAttribute("data-sidebar", "dark");
    root.setAttribute("data-sidebar-image", "none");
    root.setAttribute("data-preloader", "disable");

    root.setAttribute("data-bs-theme", this.$store.state.layout.mode || "light");
    const savedTheme = localStorage.getItem("theme");
    const theme = savedTheme || this.$store.state.layout.mode || "light";

    this.changeMode({ mode: theme });
    this.changeTopbar({ topbar: theme });

    root.setAttribute("data-bs-theme", theme);

    let backtoTop = document.getElementById("back-to-top");

    if (backtoTop) {
      window.onscroll = function () {
        if (
          document.body.scrollTop > 100 ||
          document.documentElement.scrollTop > 100
        ) {
          backtoTop.style.display = "block";
        } else {
          backtoTop.style.display = "none";
        }
      };
    }
  },
};
</script>

<template>
  <div>
    <BButton variant="danger" @click="topFunction" class="btn-icon" id="back-to-top">
      <i class="ri-arrow-up-line"></i>
    </BButton>

    <div class="customizer-setting" @click="setTheme('dark')"
      v-if="$store.state.layout.mode == 'light'">
      <div class="btn-light rounded-pill shadow-lg btn btn-icon btn-lg p-2">
        <i class="mdi mdi-moon-waning-crescent fs-22"></i>
      </div>
    </div>

    <div class="customizer-setting" @click="setTheme('light')"
      v-if="$store.state.layout.mode == 'dark'">
      <div class="btn-dark rounded-pill shadow-lg btn btn-icon btn-lg p-2">
        <i class="mdi mdi-weather-sunny fs-22"></i>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.b-overlay-wrap {
  .b-overlay {
    z-index: 1005 !important;
  }
}
</style>
